import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

// Drop this anywhere inside a <Formik> tree. When a submit attempt fails
// validation, scrolls the first invalid field into view - otherwise the
// error text can sit off-screen in a long or scrollable form and the
// submit just looks like it silently did nothing.
const ScrollToFieldError = () => {
    const { errors, isSubmitting, isValidating, submitCount } = useFormikContext();
    const lastHandledSubmitCount = useRef(0);

    useEffect(() => {
        // Nothing new to react to yet.
        if (submitCount === lastHandledSubmitCount.current) {
            return;
        }

        // Formik runs Yup validation asynchronously even for purely
        // synchronous schemas, so this effect fires more than once per
        // submit attempt. Wait for both flags to settle before deciding
        // whether there's an error to scroll to - otherwise this can read
        // `errors` before validation has actually populated it.
        if (isSubmitting || isValidating) {
            return;
        }

        lastHandledSubmitCount.current = submitCount;

        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            const el =
                document.getElementsByName(firstErrorField)[0] ||
                document.getElementById(firstErrorField);

            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                if (typeof el.focus === 'function') {
                    el.focus({ preventScroll: true });
                }
            }
        }
    }, [submitCount, isSubmitting, isValidating, errors]);

    return null;
};

export default ScrollToFieldError;
